import _ from 'lodash';

export default function (state, action) {
    if (!state) {
        state = {
            loaded: false,
            slots: [],
        };
    }

    switch (action.type) {
        case 'UPDATE_MY_AVAILABILITY':
            state = Object.assign({}, state, {
                loaded: true,
                slots: action.slots,
            });
            break;
        case 'BLOCK_AVAILABILITY_SLOT':
            state = Object.assign({}, state, {
                slots: _(state.slots)
                    .map(slot => {
                        if (slot.start == action.start && slot.end == action.end) {
                            return Object.assign({}, slot, {self_blocked: true, self_available: false});
                        }
                        return slot;
                    })
                    .value(),
            });
            break;
        case 'UNBLOCK_AVAILABILITY_SLOT':
            state = Object.assign({}, state, {
                slots: _(state.slots)
                    .map(slot => {
                        if (slot.start == action.start && slot.end == action.end) {
                            return Object.assign({}, slot, {self_blocked: false, self_available: true});
                        }
                        return slot;
                    })
                    .value(),
            });
            break;
    }

    return state;
}
